import React from 'react';
import { Button, Grid } from 'semantic-ui-react';
import { mapStatuses } from '../../helpers/liveFloor';
import RefreshSlider from '../shared/RefreshSlider';
import StatusLabels from '../shared/StatusLabels';
import OptionsList from '../systemAdmin/OptionsList';
import ExpandButton from '../shared/ExpandButton';

const MachineStatusFilters = (props) => {

  const statuses = mapStatuses(props.statuses, props.quantities);
  const { disabled, loading, filters, onSettingsClick, expanded, onExpandClick } = props;

  return (
    <Grid columns='4'>
      { filters.length > 0 &&
      <Grid.Row>
        <Grid.Column width='16'>
          <OptionsList horizontal options={filters} onChange={props.onFilterChange} />
        </Grid.Column>
      </Grid.Row>
      }
      <Grid.Row>
        <Grid.Column width='16'>
          <StatusLabels
            labels={statuses}
            onClick={props.onStatusChange}
            disabled={disabled}
          />
          <RefreshSlider refresh={props.onRefreshClick} disabled={disabled} loading={props.loading} />
          {props.allowAuthorise && <Button positive loading={props.loading} size="small" disabled={disabled} onClick={props.onAuthoriseClick}>Authorise</Button>}
          {onSettingsClick && <Button size="small" floated="right" className="ml-0_5" color="blue" disabled={loading || disabled} icon="cog" onClick={onSettingsClick} />}
          { onExpandClick && <ExpandButton content={ expanded ? "Show Details" : "Hide Details"} compact={false} active={expanded} onClick={onExpandClick} /> }
        </Grid.Column>
      </Grid.Row>
    </Grid>
  )
}


export default MachineStatusFilters;